import type { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  listIcon: {
    marginRight: theme.spacing(1),
  },
}));
